export default {
    streamNoteListedWebpages:
        'Si prega di notare che le pagine web elencate non sono di proprietà di Netvork LLP',
    streamNoteAdministrationCompliance:
        'La loro amministrazione e il rispetto della legge applicabile da parte dei loro proprietari non è responsabilità di Netvork LLP.',
    streamNoteReportEmail:
        "In caso di problemi con le landing page, si prega di segnalarli all'indirizzo e-mail",
    respectfullyTeam: 'Con rispetto, il Team Netvork',
    enterMessengerAccount: 'Inserisci l\'account del messenger',
    invalidTelegram: 'Indirizzo Telegram non valido',
    invalidSkype: 'Indirizzo Skype/Teams non valido',
};
